// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileSkillsList_avatar__-mv9w"};